import styles from "../index.less";

const hospitalType: any = {
  1: '一级医院',
  2: '二级医院',
  3: '三甲医院',
  4: '三级其他',
  5: '其他医院',
  6: '二甲医院',
}
const category: any = {
  // 医院类别
  1: '综合医院',
};


const HospitalHead = ({ data }: any) => {
  return <div className={styles.headInfo}>
  <span className={styles.h1}>{data?.hospitalName}</span>
  {data?.commonName && <p>简称：{data?.commonName}</p>}
  <div className={styles.labels}>
    {data?.isState ? <span>
      公立
    </span> : <></>}
    { data?.hospitalGrade ?
      <span>
        {hospitalType[data?.hospitalGrade]}
      </span> : <></>
    }
    { category[data?.hospitalCategory] ?
      <span>
        {category[data?.hospitalCategory]}
      </span> : <></>
    }
  </div>
</div>
}

export default HospitalHead;
